import * as React from 'react';

import { Experiment, ExperimentControl, ExperimentVariant } from '@shared-ui/experiment-context';

import { EssClientLogger } from 'typeahead-client-logger';
import { HotelName } from './hotel-name';
import { SearchFormFieldProps } from 'components/common/search-form';

interface HotelNameWrapperProps extends SearchFormFieldProps {
  essAnalyticsLogger?: EssClientLogger;
}

export class HotelNameWrapper extends React.Component<HotelNameWrapperProps> {
  render() {
    return (
      <Experiment name="Optimize_Number_Of_Typeahead_Suggestion">
        <ExperimentControl>
          <HotelName {...this.props} maxTypeaheadResults={10} />
        </ExperimentControl>
        <ExperimentVariant bucket={1}>
          <HotelName {...this.props} maxTypeaheadResults={5} />
        </ExperimentVariant>
        <ExperimentVariant bucket={2}>
          <HotelName {...this.props} maxTypeaheadResults={6} />
        </ExperimentVariant>
      </Experiment>
    );
  }
}
